const TRAILER_TYPES = ['REF', 'LOW', 'TAP', 'FLT', 'CAR', 'TAK', 'EXT'];

export default TRAILER_TYPES;
